module.exports = __webpack_public_path__ + "img/focus-practice-manager.fba5c535.png";